import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { fetchCouponsApi } from 'api/coupons-api';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  coupons: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchCouponsListing = createAsyncThunk(
  'coupons/listing',
  async (updatedParamsObject = {}, { dispatch }) => {
  try {
    const paramsObj = {
      ...updatedParamsObject,
    };
    const res = await fetchCouponsApi(paramsObj, '');
    if (res?.status) {
      dispatch(setQuickLinks(res?.user_filters));
    }
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
  },
);

const CouponsSlice = createSlice({
  name: 'coupons',
  initialState,
  reducers: {
    setCouponsLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setCouponsActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchCouponsListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchCouponsListing.fulfilled, (state, action) => {
        if (state.loading) {
          //means first time loading
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.coupons = action?.payload?.data || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchCouponsListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setCouponsActiveColumn, setCouponsLoading } = CouponsSlice.actions;
export default CouponsSlice.reducer;
